module.exports = __webpack_public_path__ + "img/2024CountywidePrivacyAwarenessTraining.f330720c.jpg";